<label *ngIf="!hideLabels" [for]="id">{{text}}
  <ng-container *ngIf="required">*&nbsp;</ng-container>
  <small *ngIf="subtext" class="text-muted">{{subtext}}</small>
</label>

<ng-container [ngSwitch]="type">

  <!-- text -->
  <input *ngSwitchCase="'text'" #input [id]="id" [attr.aria-describedby]="ariaDescribedby"
    [attr.placeholder]="placeholder" [required]="required" [disabled]="disabled" [(ngModel)]="innerValue"
    (change)="onChange($event)" (keyup)="onKeyUp(input.value)" [autofocus]="autofocus" type="text" class="form-control">

  <!-- textarea -->
  <textarea class="form-control" #textarea *ngSwitchCase="'textarea'" [id]="id" [(ngModel)]="innerValue"
    [disabled]="disabled" [required]="required" (change)="onChange($event)" (keyup)="onKeyUp(textarea.value)"
    [autofocus]="autofocus" [rows]="rows"></textarea>

  <!-- date -->
  <div *ngSwitchCase="'date'" class="input-group">
    <!-- todo tosc: fix preset values -->
    <input [id]="id" class="form-control" [(ngModel)]="dateModel" [attr.placeholder]="placeholder"
      (change)="onDateChange()" (dateSelect)="onDateChange()" #dayTemplate="" ngbDatepicker #d="ngbDatepicker"
      [required]="required" [autofocus]="autofocus" [disabled]="disabled" [placement]="placement">
    <div class="input-group-append">
      <button type="button" class="btn btn-outline-secondary" [disabled]="disabled" (click)="d.toggle()">
        <span class="oi oi-calendar" aria-hidden="true"></span>
      </button>
    </div>
  </div>

  <!-- dropdown -->
  <select *ngSwitchCase="'dropdown'" [id]="id" [value]="innerValue" [disabled]="disabled" [required]="required"
    (change)="onChange($event)" [autofocus]="autofocus" class="custom-select">
    <ng-container *ngFor="let item of selectData">
      <option [value]="item.key" [selected]="item.key == innerValue">{{item.text}}</option>
    </ng-container>
  </select>

  <!-- time-combobox -->
  <app-time-combo-box *ngSwitchCase="'time-combobox'" [preSelectedKey]="innerValue" [entries]="selectData"
    valueName="text" [id]="id" [disabled]="disabled" [required]="required" [autofocus]="autofocus"
    [targetDate]="targetDate" (selectionChanged)="onValueChange($event.key)" [firstEntryAsFallback]="firstAsDefault"
    class="custom-combobox">
  </app-time-combo-box>

  <!-- multi-dropdown -->
  <app-multi-dropdown *ngSwitchCase="'multi-dropdown'" [selectData]="selectData" [disabled]="disabled"
    [value]="innerValue" (valueChange)="onValueChange($event)" [id]="id" [ariaDescribedby]="ariaDescribedby">
  </app-multi-dropdown>

</ng-container>